import { ApiClient } from '@webapp/core/services/ApiClient'
import { createLocalStorage } from '@webapp/core/services/LocalPersistentStorage'
import { OrderDraftRepository } from './OrderDraftRepository'

export const orderDraftRepository = new OrderDraftRepository({
  httpClient: ApiClient,
  persistentStorage: createLocalStorage(),
})
